import { BrowserRouter } from "react-router-dom";
import RoutesApp from "./routes";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UsersProvider } from "./context/usersContext";
import { UnitsProvider } from "./context/unitsContext";
import { InternalsProvider } from "./context/internalContext";
import { AuxiliariesProvider } from "./context/auxiliariesContext";
import { AuthorizationProvider } from "./context/authorizationContext";
import { EducationProvider } from "./context/educationContext";
import { ProntuarioProvider } from "./context/prontuariocontext";
import { PenalExecutionProvider } from "./context/penalExecutionContext";
import { HearingsProvider } from "./context/hearingsContext";
import { HomeProvider } from "./context/homeContext";
import RateLimitNotice from "./components/RateLimitNotice";

function App() {
  return (
    <BrowserRouter className="container"
      future={{
        // Ativando flags futuras do React Router v7:
        v7_relativeSplatPath: true, // - v7_relativeSplatPath: garante resolução correta de rotas relativas dentro de rotas com '*'
        v7_startTransition: true // - v7_startTransition: melhora a performance da navegação usando React.startTransition()
      }}>

      <UsersProvider>
  <UnitsProvider>
    <InternalsProvider>
      <AuxiliariesProvider>
        <AuthorizationProvider>
          <EducationProvider>
            <ProntuarioProvider>
              <PenalExecutionProvider>
                <HearingsProvider>
                  <HomeProvider>
                    <RoutesApp />
                  </HomeProvider>
                </HearingsProvider>
              </PenalExecutionProvider>
            </ProntuarioProvider>
          </EducationProvider>
        </AuthorizationProvider>
      </AuxiliariesProvider>
    </InternalsProvider>
  </UnitsProvider>
</UsersProvider>

      <ToastContainer />
      <RateLimitNotice />
    </BrowserRouter >
  );
}

export default App;
